"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserSearchResultDto = instanceOfUserSearchResultDto;
exports.UserSearchResultDtoFromJSON = UserSearchResultDtoFromJSON;
exports.UserSearchResultDtoFromJSONTyped = UserSearchResultDtoFromJSONTyped;
exports.UserSearchResultDtoToJSON = UserSearchResultDtoToJSON;
exports.UserSearchResultDtoToJSONTyped = UserSearchResultDtoToJSONTyped;
/**
 * Check if a given object implements the UserSearchResultDto interface.
 */
function instanceOfUserSearchResultDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function UserSearchResultDtoFromJSON(json) {
    return UserSearchResultDtoFromJSONTyped(json, false);
}
function UserSearchResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
    };
}
function UserSearchResultDtoToJSON(json) {
    return UserSearchResultDtoToJSONTyped(json, false);
}
function UserSearchResultDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
    };
}
